export const polarisFeedbackLink = 'https://tally.so/r/3qod6O'
